"use strict";
/** @module BryxApi.ManagementApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin class for management SCU alert API calls.
 */
var ScuAlertsMixin = /** @class */ (function () {
    function ScuAlertsMixin() {
    }
    /**
     * Get an agency's SCU alerts
     * @param agencyId
     * @param callback
     */
    ScuAlertsMixin.prototype.getAgencySCUAlerts = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.SCUAlert.parse, 'warn'));
        };
        this.http.get("/agencies/".concat(agencyId, "/scu-alerts"), null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create a SCU alert for an agency
     * @param agencyId
     * @param name
     * @param actions
     * @param callback
     */
    ScuAlertsMixin.prototype.createAgencySCUAlert = function (agencyId, name, actions, callback) {
        var _this = this;
        var body = {
            name: name,
            actions: actions.map(function (a) { return a.toAPIParam(); }),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SCUAlert.parse));
        };
        this.http.post("/agencies/".concat(agencyId, "/scu-alerts"), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Edit a SCU alert for an agency
     * @param agencyId
     * @param scuAlertId
     * @param name
     * @param actions
     * @param callback
     */
    ScuAlertsMixin.prototype.editAgencySCUAlert = function (agencyId, scuAlertId, name, actions, callback) {
        var _this = this;
        var body = {
            name: models_1.FieldUtils.getEditableParam(name),
            actions: models_1.FieldUtils.getEditableParam(actions, function (al) { return al.map(function (a) { return a.toAPIParam(); }); }),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/agencies/".concat(agencyId, "/scu-alerts/").concat(scuAlertId), null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Delete a SCU alert for an agency
     * @param agencyId
     * @param scuAlertId
     * @param callback
     */
    ScuAlertsMixin.prototype.deleteAgencySCUAlert = function (agencyId, scuAlertId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/agencies/".concat(agencyId, "/scu-alerts/").concat(scuAlertId), null, this.unauthenticatedCallback(wrappedCallback));
    };
    return ScuAlertsMixin;
}());
exports.default = ScuAlertsMixin;
//# sourceMappingURL=ScuAlertsMixin.js.map